/* @flow */

import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { get, some, values } from 'lodash/fp';
import styled from '@emotion/styled';

import { toggleCampaignModal } from 'app/actions/userActions';
import Sidebar from 'app/components/styled/Sidebar';
import Tappable from 'app/components/commons/Tappable';
import { IN_PROGRESS } from 'app/constants/challengeStatusTypes';
import NavPrimary from './NavPrimary';

type Props = {
  blogLink?: string,
  externalLinks?: Array<*>,
  displayComboCalculator: boolean,
  displayFantasyInsider: boolean,
  displayFriends: boolean,
  displayGiftStore: boolean,
  displayGlobalLeaderboard: boolean,
  displayMyTeams: boolean,
  displayRapidFire: boolean,
  showBetWithPlayUp: boolean,
  showPlayUpCampaign: boolean,
  displayTraining: boolean,
  facebookLink?: string,
  giftStoreName: string,
  instagramLink?: string,
  isSignedIn: boolean,
  campaignButtonTitle?: string,
  logoImage?: string,
  markLive: boolean,
  offsetTop: number,
  onToggleCampaignModal: () => void,
  twitterLink?: string
};

const Inner = styled.div({
  maxWidth: 210,
  paddingTop: 80,
  paddingBottom: 10,
  width: '12vw'
});

const StyledLink = styled(Link)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});

const Logo = styled.img({
  height: 'auto',
  width: '120px'
});

class SidebarLeft extends React.PureComponent<Props> {
  props: Props;

  static defaultProps = {
    blogLink: undefined,
    externalLinks: [],
    facebookLink: undefined,
    instagramLink: undefined,
    campaignButtonTitle: undefined,
    logoImage: undefined,
    twitterLink: undefined
  };

  render() {
    const {
      blogLink,
      externalLinks,
      displayComboCalculator,
      displayFantasyInsider,
      displayFriends,
      displayGiftStore,
      displayGlobalLeaderboard,
      displayMyTeams,
      displayTraining,
      displayRapidFire,
      facebookLink,
      giftStoreName,
      instagramLink,
      isSignedIn,
      logoImage,
      markLive,
      showBetWithPlayUp,
      offsetTop,
      onToggleCampaignModal,
      showPlayUpCampaign,
      campaignButtonTitle,
      twitterLink
    } = this.props;

    return (
      <Sidebar location="left" top={`${offsetTop}px`}>
        <Inner>
          {/* {logoImage && (
            <Tappable to="/" component={StyledLink}>
              <Logo src={logoImage} alt="logo" />
            </Tappable>
          )} */}
          <NavPrimary
            blogLink={blogLink}
            externalLinks={externalLinks}
            displayComboCalculator={displayComboCalculator}
            displayFantasyInsider={displayFantasyInsider}
            displayFriends={displayFriends}
            displayGiftStore={displayGiftStore}
            displayGlobalLeaderboard={displayGlobalLeaderboard}
            displayMyTeams={displayMyTeams}
            displayTraining={displayTraining}
            displayRapidFire={displayRapidFire}
            facebookLink={facebookLink}
            giftStoreName={giftStoreName}
            instagramLink={instagramLink}
            isSignedIn={isSignedIn}
            onToggleCampaignModal={onToggleCampaignModal}
            showBetWithPlayUp={false}
            showPlayUpCampaign={showPlayUpCampaign}
            campaignButtonTitle={campaignButtonTitle}
            markLive={markLive}
            twitterLink={twitterLink}
          />
        </Inner>
      </Sidebar>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    blogLink: state.settings.blogUrl,
    externalLinks: state.settings.externalLinks || [],
    displayComboCalculator: state.settings.displayComboCalculator,
    displayFantasyInsider: state.settings.displayFantasyInsider,
    displayFriends: state.settings.displayFriends,
    displayGiftStore: state.settings.displayGiftStore,
    displayGlobalLeaderboard: state.settings.displayGlobalLeaderboard,
    displayMyTeams: state.settings.displayMyTeams,
    displayTraining: state.settings.displayTraining,
    displayRapidFire: state.settings.displayRapidFire,
    facebookLink: state.settings.social.facebookUrl,
    giftStoreName: state.settings.giftStoreName,
    instagramLink: state.settings.social.instagramUrl,
    showPlayUpCampaign: !!get('user.currentUser.hasPlayUpCampaign', state),
    campaignButtonTitle: get('user.currentUser.campaignButtonTitle', state),
    showBetWithPlayUp: !!get('user.currentUser.showBetWithPlayUp', state),
    logoImage: state.settings.logoImage,
    markLive: some({ statusId: IN_PROGRESS }, values(state.myChallenges.live.challenges)),
    twitterLink: state.settings.social.twitterUrl
  };
}

const actions = {
  onToggleCampaignModal: toggleCampaignModal
};

// IMPORTANT: the pure=false option ensures the nav updates on route change
// $FlowFixMe
export default connect(mapStateToProps, actions, null, { pure: false })(SidebarLeft);
